import { type ReactNode } from 'react';
import NextLink from 'next/link';

import { LinkButton } from '../Button/LinkButton';

import type { LinkProps } from '../../../types';

interface OptionalLinkWrapperProps extends Omit<LinkProps, 'href'> {
  children: ReactNode | string;
  href?: string;
  isExternal?: boolean;
  isUnderscoreBlankIfExternal?: boolean;
  nofollow?: boolean;
}

/**
 * @deprecated Please use the Link component for text and WithLink component for
 * components such as cards or other containers.
 *
 * This component will be replaced and its instances updated with the appropriate component in this story:
 * https://distilledsch.tpondemand.com/RestUI/Board.aspx#page=board/5702367192831126523&appConfig=eyJhY2lkIjoiNTY1MTY2MDA0MDAzMEM2ODA3MURCQjQ5M0Y4NDQxQ0MifQ==&boardPopup=userstory/110733
 */
const OptionalNextLink = (props: OptionalLinkWrapperProps) => {
  const {
    children,
    href,
    isExternal = false,
    nofollow = true,
    ...rest
  } = props;

  if (href && isExternal) {
    return (
      <a
        href={href}
        target="_blank"
        rel={`noopener noreferrer${nofollow ? ' nofollow' : ''}`}
      >
        {typeof children === 'string' ? (
          <LinkButton {...rest}>{children}</LinkButton>
        ) : (
          children
        )}
      </a>
    );
  }

  if (href) {
    return (
      <NextLink href={href} passHref legacyBehavior>
        <a>
          {typeof children === 'string' ? (
            <LinkButton {...rest}>{children}</LinkButton>
          ) : (
            children
          )}
        </a>
      </NextLink>
    );
  }

  if (typeof children === 'string') {
    return (
      <LinkButton {...rest} type="button">
        {children}
      </LinkButton>
    );
  }

  return <>{children}</>;
};

export { OptionalNextLink };
